import {post, get} from '../index'
export default {
  // 群发消息
  appSettingGroupPushMsg (querys) {
    return post('/sendmsg/sendMessage', querys)
  },
  // 短信群发
  appSettingShortMsg (querys) {
    return post('/sendmsg/shortSend', querys)
  },
  // 群发配置
  appSettingMsgConfig (querys) {
    return post('/sendmsg/editSmsConf', querys)
  },
  // 内容设置
  appSettingMsgContent (querys) {
    return post('/sendmsg/sendMessageConf', querys)
  },
  // 群发配置详情
  getAliyunInfo () {
    return get('/sendmsg/smsConfInfo')
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/groupPush.js